import ChevronDownIcon from "@atlaskit/icon/core/chevron-down";
import ChevronUpIcon from "@atlaskit/icon/core/chevron-up";
import {useState, type ReactNode} from "react";
import {AnankeTempFormSectionTitle} from "~/components/anankeTemp/anankeTempFormSectionTitle";
import {AnankeIconButton} from "@vesta/ananke/components/anankeIconButton";
import {AnankeTempVerticalSpacer} from "~/components/anankeTemp/anankeTempVerticalSpacer";

export function AnankeTempFormCollapsibleSection({
    title,
    children,
    className,
    initialIsOpen,
}: {
    title: string;
    children: ReactNode;
    className?: string;
    initialIsOpen?: boolean;
}) {
    const [isOpen, setIsOpen] = useState(() => initialIsOpen ?? true);

    return (
        <div className={className}>
            <div className="w-full grid grid-cols-[auto_minmax(0,1fr)] gap-x-1 items-center">
                <AnankeIconButton
                    type="button"
                    appearance="subtle"
                    icon={isOpen === true ? ChevronUpIcon : ChevronDownIcon}
                    onClick={() => setIsOpen(!isOpen)}
                    label=""
                />
                {/* <button
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    className={twJoin(
                        "size-4",
                        // "transition-transform duration-medium",
                        isOpen === true ? "rotate-180" : null,
                    )}
                >
                    <ChevronDownIcon label="" />
                </button> */}

                <AnankeTempFormSectionTitle title={title} />
            </div>

            {isOpen === false ? null : (
                <>
                    {/* <AnankeTempFormRowSeparator /> */}
                    <AnankeTempVerticalSpacer
                        above="sectionTitle"
                        below="formRow"
                    />

                    {children}
                </>
            )}
        </div>
    );
}
